import React from 'react'
import { Layer, Line } from 'react-konva'

import { Line as LineInterface } from '../../../reducers/editPhoto'
import { SquareLine, TriangleLine } from '../shapes'

interface AIEraserLayerProps {
    aiEraserLines: LineInterface[]
    tempAIEraserLines: LineInterface[]
}

/**
 * AI消しゴム専用レイヤー
 * 確定した線（不透明赤色）と一時的な線（透明赤色）を描画
 * このレイヤーは消しゴムとして動作しない（listening={false}）
 */
export const AIEraserLayer: React.FC<AIEraserLayerProps> = ({ aiEraserLines, tempAIEraserLines }) => {
    return (
        <Layer listening={false}>
            {/* 確定したAI消しゴムの線（不透明赤色 0.6） */}
            {aiEraserLines.map((line: LineInterface, i: number) => {
                if (line.head === 'circle')
                    return (
                        <Line
                            key={`ai-confirmed-${i}`}
                            points={line.points}
                            stroke="rgba(255, 0, 0, 0.6)"
                            strokeWidth={line.headSize}
                            tension={0.3}
                            lineCap="round"
                            lineJoin="round"
                        />
                    )
                if (line.head === 'square')
                    return (
                        <SquareLine
                            key={`ai-confirmed-${i}`}
                            line={line}
                            stroke="rgba(255, 0, 0, 0.6)"
                            fill="rgba(255, 0, 0, 0.6)"
                            opacity={1}
                        />
                    )
                if (line.head === 'triangle')
                    return (
                        <TriangleLine
                            key={`ai-confirmed-${i}`}
                            line={line}
                            stroke="rgba(255, 0, 0, 0.6)"
                            fill="rgba(255, 0, 0, 0.6)"
                            opacity={1}
                        />
                    )
                return null
            })}

            {/* AI消しゴムの一時的な線（透明赤色 0.3） */}
            {tempAIEraserLines.map((line: LineInterface, i: number) => {
                if (line.head === 'circle')
                    return (
                        <Line
                            key={`ai-temp-${i}`}
                            points={line.points}
                            stroke="rgba(255, 0, 0, 0.3)"
                            strokeWidth={line.headSize}
                            tension={0.3}
                            lineCap="round"
                            lineJoin="round"
                        />
                    )
                if (line.head === 'square')
                    return (
                        <SquareLine
                            key={`ai-temp-${i}`}
                            line={line}
                            stroke="rgba(255, 0, 0, 0.3)"
                            fill="rgba(255, 0, 0, 0.3)"
                            opacity={1}
                        />
                    )
                if (line.head === 'triangle')
                    return (
                        <TriangleLine
                            key={`ai-temp-${i}`}
                            line={line}
                            stroke="rgba(255, 0, 0, 0.3)"
                            fill="rgba(255, 0, 0, 0.3)"
                            opacity={1}
                        />
                    )
                return null
            })}
        </Layer>
    )
}
